
import { Icon } from 'semantic-ui-react';
import styles from './PersonListItem.module.css';

type Person = {
    id: number;
    name: string;
    identifier: string;
    photoUrl: string;
    preferredName?: string | null;
    scriptName?: string | null;
    tags?: { name: string }[];
};

const PersonListItem = ({
    person,
    onClick,
    showTags = false,
}: {
    person: Person;
    onClick: () => void;
    showTags?: boolean;
}) => {
    const displayName = person.preferredName
        ? `${person.name} (${person.preferredName})`
        : person.name;

    const metaParts = [person.scriptName, `ID: ${person.identifier}`].filter(Boolean);

    return (
        <div className={styles.item} onClick={onClick}>
            <img src={person.photoUrl} alt={person.name} className={styles.avatar} />
            <div className={styles.info}>
                <div className={styles.name}>{displayName}</div>
                <div className={styles.meta}>{metaParts.join(' · ')}</div>
                {showTags && person.tags && person.tags.length > 0 && (
                    <div className={styles.tags}>
                        {person.tags.map(t => (
                            <span key={t.name} className={styles.tag}>{t.name}</span>
                        ))}
                    </div>
                )}
            </div>
            <Icon name="chevron right" className={styles.chevron} />
        </div>
    );
};

export { PersonListItem };
export type { Person };
